import authRules from '../authRules';

const viewCalendar = (user) => {
  const { resourceDayTypes } = user.securityLevels;
  if (resourceDayTypes >= authRules.viewCalendar.resourceDayTypes) {
      return true;
  } else {
      return false;
    }
  }


export default viewCalendar;


// WEBPACK FOOTER //
// ./src/AuthLogic/rules/viewCalendar.js